import { render, staticRenderFns } from "./DeckPlan.vue?vue&type=template&id=1f31260a&scoped=true&"
import script from "./DeckPlan.vue?vue&type=script&lang=js&"
export * from "./DeckPlan.vue?vue&type=script&lang=js&"
import style0 from "./DeckPlan.vue?vue&type=style&index=0&id=1f31260a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f31260a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VProgressLinear,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f31260a')) {
      api.createRecord('1f31260a', component.options)
    } else {
      api.reload('1f31260a', component.options)
    }
    module.hot.accept("./DeckPlan.vue?vue&type=template&id=1f31260a&scoped=true&", function () {
      api.rerender('1f31260a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Inspection/components/DeckPlan.vue"
export default component.exports